export default {
	zh: {
		name: '简体中文'
	},
	en: {
		name: 'English'
	}
}


// WEBPACK FOOTER //
// ./src/options/lang.js